import { render, staticRenderFns } from "./BuyFromOutsourceOld.vue?vue&type=template&id=a6994d58&"
import script from "./BuyFromOutsourceOld.vue?vue&type=script&lang=js&"
export * from "./BuyFromOutsourceOld.vue?vue&type=script&lang=js&"
import style0 from "./BuyFromOutsourceOld.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports